import { default as isPlainObject } from 'lodash/isPlainObject';

import { AnyObject, Id } from '@vimeo/core/types/generic';

import { isNonEmptyString, isPlainNumber } from '../general/validators';

export type TErrorMessages = Array<string>;

export function assertNoTypeErrors(detailsMessage: string, errors: Array<string>): void {
  if (errors.length > 0) {
    throw new TypeError(`${detailsMessage}: ${errors.map((err) => `${err}, `)}`);
  }
}

interface IValidateParams<T> {
  field: T;
  fieldName: string;
  errors: TErrorMessages;
}

export function validateNumber({ field, fieldName, errors }: IValidateParams<number>) {
  if (!isPlainNumber(field)) {
    errors.push(`${fieldName} should be a number, but found ${typeof field}`);
  }
}

export function validateString({ field, fieldName, errors }: IValidateParams<string>) {
  if (!isNonEmptyString(field)) {
    errors.push(`${fieldName} should be a non-empty string, but found ${typeof field}`);
  }
}

export function validateBoolean({ field, fieldName, errors }: IValidateParams<boolean>) {
  if (typeof field !== 'boolean') {
    errors.push(`${fieldName} should be a boolean, but found ${typeof field}`);
  }
}

export function validateObject({ field, fieldName, errors }: IValidateParams<AnyObject>) {
  if (!isPlainObject(field)) {
    errors.push(`${fieldName} should be an object, but found ${typeof field}`);
  }
}

export function validateDateField({ field, fieldName, errors }: IValidateParams<number>) {
  if (!isPlainNumber(field)) {
    errors.push(`${fieldName} should be a number, but found ${typeof field}`);
  } else if (!isFinite(field)) {
    // This single check handles NaN, Infinity, and -Infinity.
    errors.push(`${fieldName} is in invalid range: ${field}`);
  }
}

export function validateStringOrNumber(params: IValidateParams<Id>) {
  if (isPlainNumber(params.field as number)) {
    validateNumber({ ...params, field: params.field as number });
  } else {
    validateString({ ...params, field: params.field as string });
  }
}
